const routes = [
    {
        path: "/housing/misconducts",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "housingmisconduct_index"
        }
    }
]

export default routes;
